import React from 'react';
import './Partners.css';  // اضافه کردن فایل CSS
import speaker from '../khodam.jpg';
import milad from '../milad.jpg';
const Speakers = () => {
  return (
    <div className="Speakers-container">
      <div className="speakers">
        <div className="group speaker_items text-white p-4 border-2 border-slate-400/20 rounded-2xl mr-4 ">
          <img className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[11.7rem] h-[11.7rem] rounded-2xl m-2 grayscale" src={speaker} alt="speaker 1" />
          <p className='text-xl font-black mt-2'>مهراد کرم پور</p>
          <p className='text-lime-500 font-light mt-2'>توسعه دهنده</p>
        </div>
        <div className="group speaker_items text-white p-4 border-2 border-slate-400/20 rounded-2xl mr-4 ">
          <img className="transition-transform group-hover:scale-105 group-hover:grayscale-0  w-[11.7rem] h-[11.7rem] rounded-2xl m-2 grayscale" src={milad} alt="speaker 1" />
          <p className='text-xl font-black mt-2'>میلاد فیاضی</p>
          <p className='text-lime-500 font-light mt-2'>مدیرعامل</p>
        </div>
        <div className="group speaker_items text-white p-4 border-2 border-slate-400/20 rounded-2xl mr-4 ">
          <img className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[11.7rem] h-[11.7rem] rounded-2xl m-2 grayscale" src={speaker} alt="speaker 1" />
          <p className='text-xl font-black mt-2'>محمد راکی</p>
          <p className='text-lime-500 font-light mt-2'>مسئول برنامه ریزی</p>
        </div>
        <div className="group speaker_items text-white p-4 border-2 border-slate-400/20 rounded-2xl mr-4 ">
          <img className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[11.7rem] h-[11.7rem] rounded-2xl m-2 grayscale" src={speaker} alt="speaker 1" />
          <p className='text-xl font-black mt-2'>احسان راکی</p>
          <p className='text-lime-500 font-light mt-2'>داور</p>
        </div>
        <div className="group speaker_items text-white p-4 border-2 border-slate-400/20 rounded-2xl mr-4 ">
          <img className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[11.7rem] h-[11.7rem] rounded-2xl m-2 grayscale" src={speaker} alt="speaker 1" />
          <p className='text-xl font-black mt-2'>محمد فتحی</p>
          <p className='text-lime-500 font-light mt-2'>داور</p>
        </div>
        <div className="group speaker_items text-white p-4 border-2 border-slate-400/20 rounded-2xl mr-4 ">
          <img className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[11.7rem] h-[11.7rem] rounded-2xl m-2 grayscale" src={speaker} alt="speaker 1" />
          <p className='text-xl font-black mt-2'>سید علی شیرمردی</p>
          <p className='text-lime-500 font-light mt-2'>سخنران</p>
        </div>
        <div className="group speaker_items text-white p-4 border-2 border-slate-400/20 rounded-2xl mr-4 ">
          <img className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[11.7rem] h-[11.7rem] rounded-2xl m-2 grayscale" src={speaker} alt="speaker 1" />
          <p className='text-xl font-black mt-2'>مهراد کرم پور</p>
          <p className='text-lime-500 font-light mt-2'>توسعه دهنده</p>
        </div>
        <div className="group speaker_items text-white p-4 border-2 border-slate-400/20 rounded-2xl mr-4 ">
          <img className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[11.7rem] h-[11.7rem] rounded-2xl m-2 grayscale" src={speaker} alt="speaker 1" />
          <p className='text-xl font-black mt-2'>مهراد کرم پور</p>
          <p className='text-lime-500 font-light mt-2'>توسعه دهنده</p>
        </div>
        <div className="group speaker_items text-white p-4 border-2 border-slate-400/20 rounded-2xl mr-4 ">
          <img className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[11.7rem] h-[11.7rem] rounded-2xl m-2 grayscale" src={speaker} alt="speaker 1" />
          <p className='text-xl font-black mt-2'>مهراد کرم پور</p>
          <p className='text-lime-500 font-light mt-2'>توسعه دهنده</p>
        </div>
        
      </div>
    </div>
  );
};

export default Speakers;
